import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import MaskedInput from 'react-input-mask';
import ContactStyles from './ContactStyles.scss';
import { Icon } from 'semantic-ui-react';
import { DthcActions, GlobalNotifications, Intent } from '../../Modules';
import {
  FloatingLabelInput as Input,
  FloatingLabelSelect as Select
} from '../../Elements';
import CountryData from 'country-data';

export default class ContactFieldsEdit extends React.Component {
  static propTypes = {
    localContact: PropTypes.object.isRequired,
    commitUpdate: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    closeHandler: PropTypes.func,
    reset: PropTypes.func.isRequired,
    delete: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    isNew: PropTypes.bool,
    hideActions: PropTypes.bool,
    deleteUserContactEmail: PropTypes.func.isRequired,
    deleteUserContactPhone: PropTypes.func.isRequired,
    deleteUserContactAddress: PropTypes.func.isRequired,
    submissionAttempts: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      submitted: this.props.submissionAttempts > 0,
      countries: this.getCountries()
    };
    this.fieldChange = this.fieldChange.bind(this);
    this.textFieldChange = this.textFieldChange.bind(this);
    this.handleRelationChange = this.handleRelationChange.bind(this);
    this.addPhone = this.addPhone.bind(this);
    this.addEmail = this.addEmail.bind(this);
    this.addAddress = this.addAddress.bind(this);
    this.handleRoleChange = this.handleRoleChange.bind(this);
    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.onInvalidSubmit = this.onInvalidSubmit.bind(this);
    this.reset = this.reset.bind(this);
    this.delete = this.delete.bind(this);
    this.generateId = this.generateId.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.submissionAttempts !== this.props.submissionAttempts) {
      this.setState({ submitted: nextProps.submissionAttempts > 0 });
    }
  }

  onValidSubmit() {
    this.setState({ submitted: true });
    this.props.commitUpdate(this.props.index, this.props.closeHandler);
  }

  onInvalidSubmit() {
    this.setState({ submitted: true });
    GlobalNotifications.show({
      message: 'Unable to update contact',
      intent: Intent.DANGER
    });
  }

  getCountries() {
    const compare = (a, b) => {
      if (a.text < b.text) {
        return -1;
      }
      if (a.text > b.text) {
        return 1;
      }
      return 0;
    };
    return CountryData.countries.all
      .slice()
      .map((country, index) => ({
        text: country.name,
        value: country.alpha2,
        key: `${country.alpha2}_${index}`
      }))
      .sort(compare);
  }

  reset(e) {
    this.props.reset(this.props.index);
    this.props.closeHandler(e);
    e.stopPropagation();
  }

  delete(e) {
    e.preventDefault();
    this.props.delete(this.props.index, () => this.props.closeHandler);
  }

  generateId() {
    return `${Math.random().toString(36)}00000000000000000`.slice(2, 16 + 2);
  }

  textFieldChange(e) {
    this.fieldChange(e.target.name, e.target.value);
  }

  handleRelationChange(e, idx, relation, field) {
    const contact = _.cloneDeep(this.props.localContact);
    const value =
      field === 'label' ? e.target.value.toLowerCase() : e.target.value;
    contact.node[relation].edges[idx].node[field] = value;
    this.props.onChange(contact);
  }

  handleRoleChange(e) {
    const contact = _.cloneDeep(this.props.localContact);
    contact.role = e.target.value;
    this.props.onChange(contact);
  }

  fieldChange(key, value) {
    const contact = _.cloneDeep(this.props.localContact);
    contact.node[key] = value;
    this.props.onChange(contact);
  }

  addPhone() {
    const contact = _.cloneDeep(this.props.localContact);
    contact.node.user_contact_phones.edges.push({
      node: { label: 'mobile', number: '', tempId: this.generateId() }
    });
    this.props.onChange(contact);
  }

  addEmail() {
    const contact = _.cloneDeep(this.props.localContact);
    contact.node.user_contact_emails.edges.push({
      node: { label: 'work', address: '', tempId: this.generateId() }
    });
    this.props.onChange(contact);
  }

  addAddress() {
    const contact = this.props.localContact;
    contact.node.user_contact_addresses.edges.push({
      node: {
        label: 'home',
        line1: '',
        line2: '',
        city: '',
        province: '',
        postal_code: '',
        country: 'US',
        tempId: this.generateId()
      }
    });
    this.props.onChange(contact);
  }

  render() {
    const localContact = this.props.localContact;

    const phoneLabelSuggestions = [
      { text: 'Mobile', value: 'mobile' },
      { text: 'Home', value: 'home' },
      { text: 'Work', value: 'work' },
      { text: 'Other', value: 'other' }
    ];

    const emailLabelSuggestions = [
      { text: 'Home', value: 'home' },
      { text: 'Work', value: 'work' },
      { text: 'Other', value: 'other' }
    ];

    const addressLabelSuggestions = [
      { text: 'Home', value: 'home' },
      { text: 'Work', value: 'work' },
      { text: 'Other', value: 'other' }
    ];

    const getLabelOptions = (selectedValue, options) => {
      const allOptions = options.slice();
      if (selectedValue) {
        let isNewValue = true;
        allOptions.map(option => {
          if (option.value === selectedValue) {
            isNewValue = false;
          }
          return option;
        });
        if (isNewValue) {
          allOptions.push({
            text: _.capitalize(selectedValue),
            value: selectedValue
          });
        }
      }
      return allOptions;
    };

    return (
      <Formsy.Form
        noValidate
        onValidSubmit={this.onValidSubmit}
        onInvalidSubmit={this.onInvalidSubmit}
      >
        <div ref='contact'>
          <Input
            label='First Name'
            name='first_name'
            placeholder='Jane'
            required
            inline
            validationError='First name is required'
            value={localContact.node.first_name}
            onChange={this.textFieldChange}
            submitted={this.state.submitted}
            width='50%'
          />
          <Input
            label='Last Name'
            name='last_name'
            placeholder='Smith'
            inline='last'
            value={localContact.node.last_name}
            onChange={this.textFieldChange}
            submitted={this.state.submitted}
            width='50%'
          />
          <Input
            label='Company Name'
            name='company_name'
            placeholder='Striking Events'
            value={localContact.node.company_name}
            onChange={this.textFieldChange}
            submitted={this.state.submitted}
          />
          <Input
            label='Role'
            name='role'
            placeholder='Bride'
            required
            validationError='Role is required'
            onChange={this.handleRoleChange}
            value={localContact.role}
            submitted={this.state.submitted}
          />
          {localContact.node.user_contact_phones.edges.map(
            (userContactPhone, idx) =>
              <div
                key={userContactPhone.node.id || userContactPhone.node.tempId}
                className={ContactStyles.relation}
              >
                <div
                  className={ContactStyles.delete}
                  onClick={this.props.deleteUserContactPhone.bind(
                    null,
                    this.props.index,
                    idx
                  )}
                >
                  <Icon name='close' />
                </div>
                <Select
                  label='Type'
                  name='label'
                  value={userContactPhone.node.label}
                  type='select'
                  onChange={e => {
                    this.handleRelationChange(
                      e,
                      idx,
                      'user_contact_phones',
                      'label'
                    );
                  }}
                  submitted={this.state.submitted}
                  placeholder='Type...'
                  options={getLabelOptions(
                    userContactPhone.node.label,
                    phoneLabelSuggestions
                  )}
                  className={ContactStyles.label}
                  inline
                  required
                  validationError='Required'
                />
                <Input
                  label='Phone'
                  type='tel'
                  name='number'
                  validations={{
                    matchRegexp: /\(\d{3}\)\s\d{3}-\d{4}|\d{10}/
                  }}
                  required
                  validationError='Phone number is invalid'
                  placeholder='(555) 555-1212'
                  value={userContactPhone.node.number}
                  onChange={e => {
                    this.handleRelationChange(
                      e,
                      idx,
                      'user_contact_phones',
                      'number'
                    );
                  }}
                  submitted={this.state.submitted}
                  className={ContactStyles.expanding}
                  inline='last'
                >
                  <MaskedInput
                    mask='(999) 999-9999'
                    value={userContactPhone.node.number}
                  />
                </Input>
              </div>
          )}
          <div className={ContactStyles.addRelation}>
            <a onClick={this.addPhone}>+ Add Phone</a>
          </div>
          {localContact.node.user_contact_emails.edges.map(
            (userContactEmail, idx) =>
              <div
                key={userContactEmail.node.id || userContactEmail.node.tempId}
                className={ContactStyles.relation}
              >
                <div
                  className={ContactStyles.delete}
                  onClick={this.props.deleteUserContactEmail.bind(
                    null,
                    this.props.index,
                    idx
                  )}
                >
                  <Icon name='close' />
                </div>
                <Select
                  label='Type'
                  name='label'
                  value={userContactEmail.node.label}
                  type='select'
                  onChange={e => {
                    this.handleRelationChange(
                      e,
                      idx,
                      'user_contact_emails',
                      'label'
                    );
                  }}
                  submitted={this.state.submitted}
                  placeholder='Type...'
                  options={getLabelOptions(
                    userContactEmail.node.label,
                    emailLabelSuggestions
                  )}
                  className={ContactStyles.label}
                  inline
                  required
                  validationError='Required'
                />
                <Input
                  label='Email'
                  type='email'
                  name='address'
                  required
                  validations='isEmail'
                  validationError='Email address is invalid'
                  placeholder='email@example.com'
                  value={userContactEmail.node.address}
                  onChange={e => {
                    this.handleRelationChange(
                      e,
                      idx,
                      'user_contact_emails',
                      'address'
                    );
                  }}
                  submitted={this.state.submitted}
                  className={ContactStyles.expanding}
                  inline='last'
                />
              </div>
          )}
          <div className={ContactStyles.addRelation}>
            <a onClick={this.addEmail}>+ Add Email</a>
          </div>
          {localContact.node.user_contact_addresses.edges.map(
            (userContactAddress, idx) =>
              <div
                key={
                  userContactAddress.node.id || userContactAddress.node.tempId
                }
              >
                <div className={ContactStyles.relation}>
                  <div
                    className={ContactStyles.delete}
                    onClick={this.props.deleteUserContactAddress.bind(
                      null,
                      this.props.index,
                      idx
                    )}
                  >
                    <Icon name='close' />
                  </div>
                  <Select
                    label='Type'
                    name='label'
                    value={userContactAddress.node.label}
                    type='select'
                    onChange={e => {
                      this.handleRelationChange(
                        e,
                        idx,
                        'user_contact_addresses',
                        'label'
                      );
                    }}
                    submitted={this.state.submitted}
                    placeholder='Type...'
                    options={getLabelOptions(
                      userContactAddress.node.label,
                      addressLabelSuggestions
                    )}
                    className={ContactStyles.label}
                    inline
                    required
                    validationError='Required'
                  />
                  <Input
                    label='Address 1'
                    name='line1'
                    placeholder='3 Elm Street'
                    value={userContactAddress.node.line1}
                    onChange={e => {
                      this.handleRelationChange(
                        e,
                        idx,
                        'user_contact_addresses',
                        'line1'
                      );
                    }}
                    submitted={this.state.submitted}
                    className={ContactStyles.expanding}
                    inline='last'
                    required
                    validationError='Address is required'
                  />
                </div>
                <div>
                  <Input
                    label='Address 2'
                    name='line2'
                    placeholder='Apt. 2B'
                    value={userContactAddress.node.line2}
                    onChange={e => {
                      this.handleRelationChange(
                        e,
                        idx,
                        'user_contact_addresses',
                        'line2'
                      );
                    }}
                    submitted={this.state.submitted}
                  />
                  <Input
                    label='City'
                    name='city'
                    placeholder='San Francisco'
                    value={userContactAddress.node.city}
                    onChange={e => {
                      this.handleRelationChange(
                        e,
                        idx,
                        'user_contact_addresses',
                        'city'
                      );
                    }}
                    submitted={this.state.submitted}
                    required
                    validationError='Required'
                  />
                  <Input
                    label='State/Province'
                    name='province'
                    placeholder='California'
                    value={userContactAddress.node.province}
                    onChange={e => {
                      this.handleRelationChange(
                        e,
                        idx,
                        'user_contact_addresses',
                        'province'
                      );
                    }}
                    submitted={this.state.submitted}
                    required
                    validationError='Required'
                  />
                  <Input
                    label='Postal Code'
                    name='postal_code'
                    placeholder='94105'
                    value={userContactAddress.node.postal_code}
                    onChange={e => {
                      this.handleRelationChange(
                        e,
                        idx,
                        'user_contact_addresses',
                        'postal_code'
                      );
                    }}
                    submitted={this.state.submitted}
                    required
                    validationError='Required'
                  />
                  <Select
                    label='Country'
                    name='country'
                    value={userContactAddress.node.country}
                    type='select'
                    onChange={e => {
                      this.handleRelationChange(
                        e,
                        idx,
                        'user_contact_addresses',
                        'country'
                      );
                    }}
                    submitted={this.state.submitted}
                    search
                    placeholder='Country...'
                    options={this.state.countries}
                    fluid
                    required
                    validationError='Country is required'
                  />
                </div>
              </div>
          )}
          <div className={ContactStyles.addRelation}>
            <a onClick={this.addAddress}>+ Add Address</a>
          </div>
          {!this.props.hideActions &&
            <DthcActions
              reset={this.reset}
              delete={this.props.delete ? this.delete : null}
              id={localContact.node.id}
              isNew={this.props.isNew}
            />}
        </div>
      </Formsy.Form>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/ContactFields.js